import { SegmentationIds } from 'constants/segmentation';
import { InputProductType } from 'interfaces/api-input/input-product-type';
import { ProductType } from 'interfaces/product';

export default {
  'common:pieces': 'pcs',
  'common:allergies': 'Allergies',
  'common:name': 'Name',
  'common:name:mandatory': 'Mandatory field',
  'common:name:optional': 'Optional',
  'common:breed': 'Breed',
  'common:age': 'Age',
  'common:weight': 'Weight',
  'common:body-condition': 'Body Condition Score',
  'common:activity-level': 'Activity level',
  'common:need': 'Need',
  'common:back': 'Back',
  'common:close': 'Close',
  'common:submit': 'Save',
  'common:create': 'Create',
  'common:and': 'and',
  'common:still': 'Still',
  'common:add': 'Add',
  'common:password': 'Password',
  'common:password:optional': 'Password (Optional)',
  'common:selected': 'Selected',
  'common:buttons:load-more': 'Show more',
  'common:buttons:learn-more': 'Learn more',
  'common:buttons:select': 'Please select',
  'common:buttons:cancel': 'Cancel',
  'common:buttons:back': 'Back',
  'common:buttons:continue': 'Continue',
  'common:add-to-cart': 'Add to cart',
  'common:products': 'Products',
  'common:promotions': 'Promotions',
  'common:price:shipping': 'Shipping',
  'common:price:totalPrice': 'Total price',
  'common:price:tax': 'incl. VAT',
  'common:price:totalWithTax': 'Total incl. VAT',
  'common:price:discount': 'Discount',
  'common:price:from': 'from',
  'common:product:add': 'Add',
  'common:product:variant': 'Variant',
  'common:product:quantity': 'Quantity',
  'common:product:interval': 'Interval',
  'common:product:size': 'Size',
  'common:product:to-the-porduct': 'To the product',
  'common:button:confrim': 'Confirm',
  'common:input:required': 'Mandatory field',
  'common:input:street:number-required': 'Street must include a house number',
  'common:input:street:letter-required': 'Street must contain at least one letter',
  'common:input:street:min-length': 'Street must be at least 2 characters long',
  'common:product:out-of-stock': 'Out of stock',
  'common:product:image-placeholder': 'Product image',
  'common:alt': 'Image for',
  'common:product:bundle-contains': '<b>Trial package contains</b> {productsList}',
  'common:address:shipping-address': 'Shipping address',
  'common:address:billing-address': 'Billing address',
  'common:payment:payment-method': 'Payment method',
  'common:unknown': 'Unknown',
  'common:loading': 'Loading...',
  'common:country:de': 'Germany',
  'common:country:at': 'Austria',
  'common:country:ch': 'Switzerland',
  'common:country:nl': 'Netherlands',
  'common:for-dogs': 'For dogs',
  'common:dogs': 'Dogs',
  'common:for-cats': 'For cats',
  'common:cats': 'Cats',
  'common:pet-type': 'Pet type',
  'common:pet-type:dog': 'dog',
  'common:pet-type:cat': 'cat',
  'common:birthday': 'Birthday',
  'common:add-item': 'Add',
  'common:remove-item': 'Remove',
  'common:understood': 'Understood',
  'common:saved': 'Saved',
  'common:error:failed-to-save': 'Saving failed. Please try again later.',
  'common:undo': 'Undo',
  'common:feed-type': 'Food type',
  'common:taste': 'Taste',
  'common:consistency': 'Consistency',
  'common:snack': 'Snack type',

  'common:shop-switcher:title': 'Are you on the right track?',
  'common:shop-switcher:stay': 'No, stay here',

  'common:shop-switcher:to:DE:button': 'Yes, go to the German shop',
  'common:shop-switcher:to:DE:text':
    'On petsdeli.de, deliveries to Germany and Austria are possible. Would you like to switch to the German shop?',

  'common:shop-switcher:to:CH:button': 'Yes, go to the Swiss shop',
  'common:shop-switcher:to:CH:text':
    'On petsdeli.ch, deliveries to Switzerland are possible. Would you like to switch to the Swiss shop?',

  'common:shop-switcher:to:NL:button': 'Yes, go to the Dutch shop',
  'common:shop-switcher:to:NL:text':
    'On petsdeli.nl, deliveries to the Netherlands are possible. Would you like to switch to the Dutch shop?',

  'common:tabs-accordeon:product-info': 'Product information',
  'common:tabs-accordeon:product-info:plural': 'Product information',
  'common:product-info-preview:read-more': 'Show more',
  'common:product-info-preview:read-less': 'Show less',
  'common:tabs-accordeon:badge-new': 'New',
  [`common:breed:${SegmentationIds.Bulldog}`]: 'Bulldogs',
  [`common:breed:${SegmentationIds.Chihuahua}`]: 'Chihuahuas',
  [`common:breed:${SegmentationIds.Dachshund}`]: 'Dachshunds',
  [`common:breed:${SegmentationIds.Havanese}`]: 'Maltese',
  [`common:breed:${SegmentationIds.Poodle}`]: 'Poodles',
  [`common:breed:${SegmentationIds.Retriever}`]: 'Retrievers',
  [`common:breed:${SegmentationIds.ShepherdDog}`]: 'Shepherd Dogs',
  [`common:breed:${SegmentationIds.Spitz}`]: 'Spitz',
  [`common:breed:${SegmentationIds.Terrier}`]: 'Terriers',
  [`common:breed:${SegmentationIds.Herdingdog}`]: 'Herding Dogs',
  [`common:breed:${SegmentationIds.MixedLarge}`]: 'Mixed breed (large)',
  [`common:breed:${SegmentationIds.MixedSmall}`]: 'Mixed breed (small)',
  [`common:breed:${SegmentationIds.OtherBreed}`]: 'Other breed',

  [`common:age:${SegmentationIds.Welpe}`]: 'Puppy',
  [`common:age:${SegmentationIds.DogAdult}`]: 'Adult',
  [`common:age:${SegmentationIds.DogSenior}`]: 'Senior',
  [`common:age:${SegmentationIds.Kitten}`]: 'Kitten',
  [`common:age:${SegmentationIds.CatAdult}`]: 'Adult',
  [`common:age:${SegmentationIds.CatSenior}`]: 'Senior',

  [`common:allergy:${SegmentationIds.GrainFree}`]: 'Grain',
  [`common:allergy:${SegmentationIds.Beef}`]: 'Beef',
  [`common:allergy:${SegmentationIds.Chicken}`]: 'Chicken',
  [`common:allergy:${SegmentationIds.Duck}`]: 'Duck',
  [`common:allergy:${SegmentationIds.Fish}`]: 'Fish',
  [`common:allergy:${SegmentationIds.Lamb}`]: 'Lamb',
  [`common:allergy:${SegmentationIds.Horse}`]: 'Horse',
  [`common:allergy:${SegmentationIds.Goat}`]: 'Goat',
  [`common:allergy:${SegmentationIds.SweetPotato}`]: 'Sweet potatoes',
  [`common:allergy:${SegmentationIds.Potato}`]: 'Potatoes',
  [`common:allergy:${SegmentationIds.Poultry}`]: 'Poultry',
  [`common:allergy:${SegmentationIds.Deer}`]: 'Deer',
  [`common:allergy:${SegmentationIds.Rabbit}`]: 'Rabbit',
  [`common:allergy:${SegmentationIds.Veal}`]: 'Veal',
  [`common:allergy:${SegmentationIds.Kangaroo}`]: 'Kangaroo',
  [`common:allergy:${SegmentationIds.Salmon}`]: 'Salmon',
  [`common:allergy:${SegmentationIds.Turkey}`]: 'Turkey',
  [`common:allergy:${SegmentationIds.Tuna}`]: 'Tuna',
  [`common:allergy:${SegmentationIds.Game}`]: 'Game',
  [`common:allergy:${SegmentationIds.Pork}`]: 'Pork',

  [`common:product-type:${ProductType.WetFood}`]: 'Wet food',
  [`common:product-type:${ProductType.DryFood}`]: 'Dry food',
  [`common:product-type:${ProductType.FoodSupplement}`]: 'Food supplement',
  [`common:product-type:${ProductType.Med}`]: 'Med',
  [`common:product-type:${ProductType.FreshMenus}`]: 'BARF',
  [`common:product-type:${ProductType.Snacks}`]: 'Snacks',
  [`common:product-type:${ProductType.Accessories}`]: 'Accessories',
  [`common:product-type:${ProductType.Gift}`]: 'Gift',
  [`common:product-type:${ProductType.Care}`]: 'Care',
  [`common:product-type:${ProductType.Testpaket}`]: 'Trial package',
  [`common:product-type:${InputProductType.WetFood}`]: 'Wet food',
  [`common:product-type:${InputProductType.DryFood}`]: 'Dry food',
  [`common:product-type:${InputProductType.FoodSupplement}`]: 'Food supplement',
  [`common:product-type:${InputProductType.Med}`]: 'Med',
  [`common:product-type:${InputProductType.Barf}`]: 'BARF',
  [`common:product-type:${InputProductType.Snacks}`]: 'Snacks',
  [`common:product-type:${InputProductType.Accessories}`]: 'Accessories',
  [`common:product-type:${InputProductType.Gift}`]: 'Gift',
  [`common:product-type:${InputProductType.Care}`]: 'Care',
  [`common:product-type:${InputProductType.TestPackage}`]: 'Trial package',
  'common:bestseller': 'Bestseller',

  'common:hero-filter:nassfutter': 'Wet food',
  'common:hero-filter:trockenfutter': 'Dry food',
  'common:hero-filter:barf': 'BARF',
  'common:hero-filter:snacks': 'Snacks',
  'common:hero-filter:all': 'All',

  'common:one-time-purchase:title': 'One-time delivery',

  'common:pet-profile:age-selector:title': 'Age',
  'common:pet-profile:age-selector:chip:welpe': 'Puppy (0-1 years)',
  'common:pet-profile:age-selector:chip:dog-adult': 'Adult (1-8 years)',
  'common:pet-profile:age-selector:chip:senior': 'Senior (from 8 years)',
  'common:pet-profile:age-selector:chip:kitten': 'Kitten (0-1 years)',
  'common:pet-profile:age-selector:chip:adultcat': 'Adult (1-10 years)',
  'common:pet-profile:age-selector:chip:seniorcat': 'Senior (10+ years)',
  'common:pet-profile:age-selector:desktop-age-selector:welpe': 'Junior',
  'common:pet-profile:age-selector:desktop-age-selector:description:welpe': 'up to 1 year',
  'common:pet-profile:age-selector:desktop-age-selector:dog-adult': 'Adult',
  'common:pet-profile:age-selector:desktop-age-selector:description:dog-adult':
    'between 1 and 8 years',
  'common:pet-profile:age-selector:desktop-age-selector:senior': 'Senior',
  'common:pet-profile:age-selector:desktop-age-selector:description:senior': 'from 8 years',
  [`common:pet-profile:age-selector:desktop-age-selector:${SegmentationIds.Kitten}`]: 'Kitten',
  [`common:pet-profile:age-selector:desktop-age-selector:${SegmentationIds.CatAdult}`]: 'Adult',
  [`common:pet-profile:age-selector:desktop-age-selector:${SegmentationIds.CatSenior}`]: 'Senior',
  [`common:pet-profile:age-selector:desktop-age-selector:description:${SegmentationIds.Kitten}`]:
    'up to 1 year',
  [`common:pet-profile:age-selector:desktop-age-selector:description:${SegmentationIds.CatAdult}`]:
    'between 1 and 10 years',
  [`common:pet-profile:age-selector:desktop-age-selector:description:${SegmentationIds.CatSenior}`]:
    '10+ years',
  'common:pet-profile:body-condition-selector:chip:1': 'Very lean',
  'common:pet-profile:body-condition-selector:chip:2': 'Slightly lean',
  'common:pet-profile:body-condition-selector:chip:3': 'Ideal shape',
  'common:pet-profile:body-condition-selector:chip:4': 'Slightly rounded',
  'common:pet-profile:body-condition-selector:chip:5': 'Well padded',
  'common:pet-profile:body-condition-selector:description:1': 'Very lean',
  'common:pet-profile:body-condition-selector:description:2': 'Slightly lean',
  'common:pet-profile:body-condition-selector:description:3': 'Ideal shape',
  'common:pet-profile:body-condition-selector:description:4': 'Slightly rounded',
  'common:pet-profile:body-condition-selector:description:5': 'Well padded',
  'common:pet-profile:activity-level-selector:chip:low': 'Low activity',
  'common:pet-profile:activity-level-selector:chip:medium': 'Normal activity',
  'common:pet-profile:activity-level-selector:chip:high': 'High activity',
  'common:pet-profile:activity-level-selector:description:low': 'Low activity',
  'common:pet-profile:activity-level-selector:description:medium': 'Normal activity',
  'common:pet-profile:activity-level-selector:description:high': 'High activity',
  'common:pet-profile:breed-selector:title': 'Please select a breed:',
  [`common:pet-profile:breed-selector:${SegmentationIds.Bulldog}`]: 'Bulldog',
  [`common:pet-profile:breed-selector:${SegmentationIds.Chihuahua}`]: 'Chihuahua',
  [`common:pet-profile:breed-selector:${SegmentationIds.Dachshund}`]: 'Dachshund',
  [`common:pet-profile:breed-selector:${SegmentationIds.Havanese}`]: 'Havanese & Maltese',
  [`common:pet-profile:breed-selector:${SegmentationIds.Herdingdog}`]: 'Herding dog',
  [`common:pet-profile:breed-selector:${SegmentationIds.MixedLarge}`]: 'Mixed breed (large)',
  [`common:pet-profile:breed-selector:${SegmentationIds.MixedSmall}`]: 'Mixed breed (small)',
  [`common:pet-profile:breed-selector:${SegmentationIds.Poodle}`]: 'Poodle & Poodle mix',
  [`common:pet-profile:breed-selector:${SegmentationIds.Retriever}`]: 'Retriever',
  [`common:pet-profile:breed-selector:${SegmentationIds.ShepherdDog}`]: 'Shepherd dog',
  [`common:pet-profile:breed-selector:${SegmentationIds.Spitz}`]: 'Spitz',
  [`common:pet-profile:breed-selector:${SegmentationIds.Terrier}`]: 'Terrier',
  [`common:pet-profile:breed-selector:${SegmentationIds.OtherBreed}`]: 'Other breed',
  'common:pet-profile:needs-selector:title': 'Needs:',
  'common:pet-profile:needs-selector:pickyeater': 'Picky eater',
  'common:pet-profile:needs-selector:overweight': 'Overweight',
  'common:pet-profile:needs-selector:intolerance': 'Allergies & Intolerances',
  'common:pet-profile:needs-selector:intolerance-subtitle':
    'Select the ingredients you want to avoid (optional):',
  'common:pet-profile:needs-selector:digestion': 'Digestive problems',
  'common:pet-profile:needs-selector:skin-fur': 'Skin & fur problems',
  'common:pet-profile:needs-selector:pickyeater-description': 'Fussy, restless, bloated',
  'common:pet-profile:needs-selector:overweight-description': 'Lethargy, no visible waist',
  'common:pet-profile:needs-selector:intolerance-description':
    'Itching, diarrhea, stomach rumbling',
  'common:pet-profile:needs-selector:digestion-description': 'Diarrhea, bloating, tenderness',
  'common:pet-profile:needs-selector:skin-fur-description': 'Scratching, licking, bald spots',
  'common:pet-profile:needs-selector:prevention': 'Health prevention',
  'common:pet-profile:needs-selector:prevention-description':
    'Immune system, digestive balance, vitality, joints',
  [`common:pet-profile:needs-selector:${SegmentationIds.CatPickyEater}`]: 'Picky eater',
  [`common:pet-profile:needs-selector:${SegmentationIds.CatDigestion}`]: 'Digestive problems',
  [`common:pet-profile:needs-selector:${SegmentationIds.CatOverweight}`]: 'Overweight',
  [`common:pet-profile:needs-selector:${SegmentationIds.SkinFurCat}`]: 'Skin & fur problems',
  [`common:pet-profile:needs-selector:${SegmentationIds.ImmuneSystem}`]: 'Immunity+',
  [`common:pet-profile:needs-selector:${SegmentationIds.IntoleranceCat}`]:
    'Allergies / Intolerances',
  [`common:pet-profile:needs-selector:${SegmentationIds.HairballHelp}`]: 'Hairball help',
  [`common:pet-profile:needs-selector:${SegmentationIds.CatPickyEater}-description`]:
    'Fussy, restless, bloated',
  [`common:pet-profile:needs-selector:${SegmentationIds.CatDigestion}-description`]:
    'Diarrhea, bloating, constipation, loss of appetite',
  [`common:pet-profile:needs-selector:${SegmentationIds.CatOverweight}-description`]:
    'Lethargy, no visible waist, weight gain',
  [`common:pet-profile:needs-selector:${SegmentationIds.ImmuneSystem}-description`]:
    'Support for the immune system',
  [`common:pet-profile:needs-selector:${SegmentationIds.IntoleranceCat}-description`]:
    'Itching, diarrhea, stomach rumbling',
  [`common:pet-profile:needs-selector:${SegmentationIds.SkinFurCat}-description`]:
    'Scratching, licking, bald spots',
  [`common:pet-profile:needs-selector:${SegmentationIds.HairballHelp}-description`]:
    'Supports digestion of hairballs',
  'common:pet-profile:allergy': 'Intolerance',
  'common:show-more': 'Show more',
  'common:show-less': 'Show less',
};
